import self from '@/common/utils/global-config';

// 就诊人列表成功回调
export function getPatientInfoByConditionComplete(result) {
  if (result.data && result.data.code === 0 && result.data.data && self.$sn.validate.array(result.data.data)) {
    self.$sn.utils.setHospitalLocalStorage('Login_PatientList', result.data.data);
    if (result.data.data.length > 0) {
      let serial = 0;
      if (self.$sn.utils.getCurrentPatient()) {
        serial = result.data.data.findIndex(res => res.patientId === self.$sn.utils.getCurrentPatient().patientId);
      }
      else {
        serial = result.data.data.findIndex(res => res.defaultState === '1');
      }
      if (serial < 0) serial = 0;
      self.$sn.utils.setHospitalLocalStorage('CurrentPatient', result.data.data[serial]);
    }
  }
  else {
    if (self.$sn.utils.getHospitalLocalStorage('Login_PatientList')) {
      self.$sn.utils.removeHospitalLocalStorage('Login_PatientList');
    }
    if (self.$sn.utils.getCurrentPatient()) {
      self.$sn.utils.removeHospitalLocalStorage('CurrentPatient');
    }
  }
}

export function deletePatientInfoComplete(result, params) {
  if (result.data && result.data.code === 0) {
    let storage = self.$sn.utils.getHospitalLocalStorage('Login_PatientList');
    storage = storage.filter(res => res.patientId !== params.id);
    self.$sn.utils.setHospitalLocalStorage('Login_PatientList', storage);
  }
}

export function getHospitalIntermediateComplete(result) {
  if (result.data && result.data.code === 0 && result.data.data && self.$sn.validate.json(result.data.data)) {
    return JSON.parse(result.data.data);
  }
  else {
    return null;
  }
}

export function ordinaryTransmitLoginComplete(result) {
  if (result.data && result.data.data) {
    result.data.data = eval('(' + result.data.data + ')');
  }
  return result.data;
}
